import axios from 'axios';

const getSupportTickets = async ({ user, page = 1, perPage = 10 }) => {
  const searchParams = new URLSearchParams();

  searchParams.append('page', page);
  searchParams.append('perPage', perPage);

  if (user) searchParams.append('user', user);

  const params = searchParams.toString();

  const { data: { supportTickets, count } } = await axios.get(`${process.env.REACT_APP_API_URL}/support-tickets?${params}`);

  return { supportTickets, count };
};

const createSupportTicket = async ({ user, title, description, priority }) => {
  const payload = { user, title, description };

  if (priority) payload.priority = priority;

  const { data: supportTicket } = await axios.post(`${process.env.REACT_APP_API_URL}/support-tickets`, payload);

  return supportTicket;
};

const addMessageToTicket = async ({ ticketId, user, message }) => {
  const payload = { user, message };

  const { data: sentMessage } = await axios.post(`${process.env.REACT_APP_API_URL}/support-tickets/${ticketId}/messages`, payload);

  return { sentMessage };
}

const updateSupportTicket = async ({ ticketId, title, description, status, priority }) => {
  const payload = {};

  if (title) payload.title = title;
  if (description) payload.description = description;
  if (status) payload.status = status;
  if (priority) payload.priority = priority;

  const { data: updatedTicket } = await axios.put(`${process.env.REACT_APP_API_URL}/support-tickets/${ticketId}`, payload);

  return updatedTicket;
};

const deleteSupportTicket = async (ticketId) => {
  const { data: supportTicket } = await axios.delete(`${process.env.REACT_APP_API_URL}/support-tickets/${ticketId}`);

  return supportTicket;
}

const supportTicketService = {
  getSupportTickets,
  createSupportTicket,
  addMessageToTicket,
  updateSupportTicket,
  deleteSupportTicket
};

export default supportTicketService;
